var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          class: _vm.fileList.length < _vm.limit ? "" : "isHidden",
          attrs: {
            action: _vm.actionUrl,
            "list-type": "picture-card",
            accept: _vm.fileType,
            multiple: true,
            headers: _vm.headers,
            "with-credentials": true,
            "auto-upload": true,
            limit: _vm.limit,
            "file-list": _vm.fileList,
            disabled: _vm.boxType === "view",
            "on-success": _vm.handleSuccess,
            "on-preview": _vm.handlePreview,
            "on-remove": _vm.handleRemove,
            "on-error": _vm.handleError,
            "on-exceed": _vm.handleExceed,
            "before-upload": _vm.beforeUpload,
          },
        },
        [
          _c("i", { staticClass: "el-icon-plus" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [
              _vm.tagType &&
              _vm.tagType() &&
              _vm.tagTxt &&
              _vm.tagTxt() &&
              _vm.limit === 1 &&
              _vm.boxType !== "add" &&
              _vm.init &&
              !_vm.isEmpty(_vm.value)
                ? _c(
                    "div",
                    [
                      _c(
                        "el-tag",
                        { attrs: { type: _vm.tagType(), effect: "dark" } },
                        [_vm._v(_vm._s(_vm.tagTxt()))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.fileType
                ? _c("span", [
                    _vm._v("只能上传" + _vm._s(_vm.fileType) + "文件"),
                  ])
                : _vm._e(),
              _vm.fileType && _vm.maxSize
                ? _c("span", [_vm._v("，")])
                : _vm._e(),
              _vm.maxSize
                ? _c("span", [
                    _vm._v("文件不超过" + _vm._s(_vm.maxSize) + "kb"),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "10vh",
            title: "预览图片",
            modal: false,
            "modal-append-to-body": false,
            visible: _vm.dialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { "object-fit": "contain", width: "100%" },
            attrs: { src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }